type Line = {
  id: string;
  quantity: number;
};

type Params = {
  lines: Line[];
  currentUnitCosts: Map<string, number>;
  nestedUnitCosts: Map<string, number>;
};

export const computeNestingMaterialGain = ({
  lines,
  currentUnitCosts,
  nestedUnitCosts,
}: Params): number | null => {
  const hasEveryCost = lines.every(({ id }) => currentUnitCosts.has(id) && nestedUnitCosts.has(id));
  if (lines.length === 0 || !hasEveryCost) {
    return null;
  }

  const gain = lines.reduce(
    (sum, { id, quantity }) =>
      sum + quantity * ((currentUnitCosts.get(id) ?? 0) - (nestedUnitCosts.get(id) ?? 0)),
    0,
  );

  return Math.max(gain, 0);
};
